import { render } from "./cdrBatchAllocation.vue?vue&type=template&id=6dea1317&scoped=true"
import script from "./cdrBatchAllocation.vue?vue&type=script&lang=js"
export * from "./cdrBatchAllocation.vue?vue&type=script&lang=js"

import "./cdrBatchAllocation.vue?vue&type=style&index=0&id=6dea1317&scoped=true&lang=css"
import "./cdrBatchAllocation.vue?vue&type=style&index=1&id=6dea1317&lang=css"
script.render = render
script.__scopeId = "data-v-6dea1317"

export default script